/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_EmptyInputs */

const en_us2_workout_quick_empty = /** @type {(inputs: Workout_Quick_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This workout has no exercises. You can still mark it done.`)
};

const pt_br2_workout_quick_empty = /** @type {(inputs: Workout_Quick_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este treino não tem exercícios. Você ainda pode marcá-lo como feito.`)
};

const es_419_workout_quick_empty = /** @type {(inputs: Workout_Quick_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este entrenamiento no tiene ejercicios. Igual puedes marcarlo como hecho.`)
};

const pt_pt2_workout_quick_empty = /** @type {(inputs: Workout_Quick_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este treino não tem exercícios. Ainda podes marcá-lo como feito.`)
};

const fr_fr2_workout_quick_empty = /** @type {(inputs: Workout_Quick_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette séance n'a aucun exercice. Tu peux quand même la marquer comme faite.`)
};

const de_de2_workout_quick_empty = /** @type {(inputs: Workout_Quick_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Training hat keine Übungen. Du kannst es trotzdem als erledigt markieren.`)
};

const it_it2_workout_quick_empty = /** @type {(inputs: Workout_Quick_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo allenamento non ha esercizi. Puoi comunque segnarlo come fatto.`)
};

/**
* | output |
* | --- |
* | "This workout has no exercises. You can still mark it done." |
*
* @param {Workout_Quick_EmptyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_empty = /** @type {((inputs?: Workout_Quick_EmptyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_EmptyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_empty(inputs)
	if (locale === "es-419") return es_419_workout_quick_empty(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_empty(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_empty(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_empty(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_empty(inputs)
	return en_us2_workout_quick_empty(inputs)
});
export { workout_quick_empty as "workout-quick.empty" }